import { useDispatch } from 'react-redux'
import { createJobApplication } from 'store/Recruitment/actions'
import { setFormSubmitted } from 'store/Recruitment/actions'
import CreateJobInput from '../CreateJob/CreateJobInput'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { getJobScreenings } from 'store/Recruitment/actions'

function ApplyForm({ onSuccessFn = () => {}, ownApply = false }) {
  const location = useLocation()
  const dispatch = useDispatch()

  const { jobProps, jobScreenings, errorMessage } = useSelector(
    (store) => store.recruitment
  )

  const askGender = jobProps?.find((el) => el?.name === 'gender')?.value
  const askBirthDate = jobProps?.find(
    (el) => el?.name === 'date_of_birth'
  )?.value
  const askCountry = jobProps?.find((el) => el?.name === 'country')?.value
  const askProfileImage = jobProps?.find(
    (el) => el?.name === 'profile_image'
  )?.value
  const askCoverLetter = jobProps?.find(
    (el) => el?.name === 'cover_letter'
  )?.value
  const askResume = jobProps?.find((el) => el?.name === 'resume')?.value
  const customQuestionsIds = jobProps?.find(
    (el) => el?.name === 'custom_questions'
  )

  const { value: jobTitle } = jobProps?.find((el) => el?.name === 'title') ?? ''

  const [customQuestions, setCustomQuestions] = useState([])

  const [name, setName] = useState('')
  const [applicationType, setApplicationType] = useState(null)
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [gender, setGender] = useState(null)
  const [country, setCountry] = useState('')
  const [coverLetter, setCoverLetter] = useState('')
  const [profile, setProfile] = useState(null)
  const [resume, setResume] = useState(null)
  const [customAnswers, setCustomAnswers] = useState({})

  const [formKey, setFormKey] = useState(0)

  useEffect(() => {
    dispatch(getJobScreenings())
  }, [dispatch])

  useEffect(() => {
    setCustomQuestions(
      jobScreenings?.filter((el) => customQuestionsIds?.value?.includes(el?.id))
    )
  }, [customQuestionsIds, jobScreenings])

  useEffect(() => {
    if (ownApply) {
      setApplicationType({ name: 'New', value: 'new' })
    }
  }, [ownApply])

  const resetForm = () => {
    setName('')
    setApplicationType(null)
    setEmail('')
    setPhone('')
    setDateOfBirth('')
    setGender(null)
    setCountry('')
    setCoverLetter('')
    setProfile(null)
    setResume(null)
    setCustomAnswers({})

    setFormKey((prev) => prev + 1)
  }

  return (
    <form
      key={formKey}
      id='application'
      onSubmit={async (e) => {
        e.preventDefault()

        dispatch(setFormSubmitted(true))

        const answers = Object?.entries(customAnswers)?.map(([id, answer]) => ({
          id: Number(id),
          answer,
        }))

        let isValid =
          applicationType &&
          name?.trim() &&
          email?.trim() &&
          phone?.trim() &&
          customQuestions
            .filter((q) => q.is_required)
            .every((q) => customAnswers[q.id]?.trim())

        if (ownApply) {
          if (askBirthDate && !dateOfBirth) isValid = false
          if (askGender && !gender?.option?.value) isValid = false
          if (askCountry && !country?.trim()) isValid = false
          if (askCoverLetter && !coverLetter?.trim()) isValid = false
          if (askProfileImage && !profile) isValid = false
          if (askResume && !resume) isValid = false
        }

        if (!isValid) return

        const formData = new FormData()
        formData.append('job_id', location?.search?.split('=')?.at(1))
        formData.append(
          'application_type',
          applicationType?.option?.value ?? applicationType?.value
        )
        formData.append('name', name)
        formData.append('email', email)
        formData.append('phone', phone)
        formData.append('date_of_birth', dateOfBirth || '')
        formData.append('gender', gender?.option?.value || '')
        formData.append('country', country || '')
        formData.append('cover_letter', coverLetter || '')
        formData.append('answers', JSON.stringify(answers))

        if (profile) formData.append('profile', profile)
        if (resume) formData.append('resume', resume)

        const result = await dispatch(
          createJobApplication(formData, location?.search?.split('=')?.at(1))
        )

        if (!result.success) {
          return
        }

        if (onSuccessFn) {
          onSuccessFn()
        }

        if (ownApply) {
          dispatch(setFormSubmitted(false))
          resetForm()
        }
      }}
    >
      <div className='d-flex flex-wrap w-100' style={{ gap: '0rem 1rem' }}>
        {!ownApply ? (
          <>
            <CreateJobInput
              id='jobTitle'
              placeholder='Select Job'
              label='Job'
              required={true}
              fullSize={false}
              select={true}
              options={{ name: jobTitle, value: jobTitle }}
              selectedOptions={{ name: jobTitle, value: jobTitle }}
            />
            <CreateJobInput
              id='applicationType'
              placeholder='Select Application Type'
              label='Application Type'
              required={true}
              fullSize={false}
              select={true}
              options={[
                { name: 'New', value: 'new' },
                { name: 'Job Candidate', value: 'job_candidate' },
              ]}
              onChange={(val) => setApplicationType(val)}
              selectedOptions={applicationType}
            />
          </>
        ) : null}

        <CreateJobInput
          id='name'
          placeholder='Enter Name'
          label='Name'
          required={ownApply || true}
          fullSize={false}
          defaultValue={name}
          onChange={(val) => setName(val)}
        />
        <CreateJobInput
          id='email'
          placeholder='Enter Email'
          label='Email'
          required={ownApply || true}
          fullSize={false}
          defaultValue={email}
          onChange={(val) => setEmail(val)}
        />
        <CreateJobInput
          id='phone'
          placeholder='Enter Phone'
          label='Phone'
          required={ownApply || true}
          fullSize={false}
          defaultValue={phone}
          onChange={(val) => setPhone(val)}
        />
        <CreateJobInput
          id='dateOfBirth'
          placeholder='Enter Phone'
          label='Date of Birth'
          fullSize={false}
          required={ownApply}
          defaultValue={dateOfBirth}
          type='date'
          display={!askBirthDate && 'd-none'}
          onChange={(val) => setDateOfBirth(val)}
        />
        <CreateJobInput
          id='gender'
          placeholder='Select Gender'
          label='Gender'
          fullSize={false}
          required={ownApply}
          select={true}
          display={!askGender && 'd-none'}
          options={[
            { name: 'Male', value: 'm' },
            { name: 'Female', value: 'f' },
          ]}
          onChange={(val) => setGender(val)}
          selectedOptions={gender}
        />
        <CreateJobInput
          id='country'
          placeholder='Enter Country'
          label='Country'
          defaultValue={country}
          required={ownApply}
          fullSize={false}
          display={!askCountry && 'd-none'}
          onChange={(val) => setCountry(val)}
        />
        <CreateJobInput
          id='coverLetter'
          placeholder='Enter Cover Letter'
          label='Cover Letter'
          defaultValue={coverLetter}
          required={ownApply}
          fullSize={true}
          type='textarea'
          display={!askCoverLetter && 'd-none'}
          onChange={(val) => setCoverLetter(val)}
        />
        <CreateJobInput
          id='profile'
          label='Profile'
          fullSize={false}
          required={ownApply}
          type='file'
          display={!askProfileImage && 'd-none'}
          onChange={(val) => setProfile(val)}
        />
        <CreateJobInput
          id='profile'
          label='CV / Resume'
          fullSize={false}
          required={ownApply}
          type='file'
          display={!askResume && 'd-none'}
          onChange={(val) => setResume(val)}
        />
        {customQuestions && customQuestions.length
          ? customQuestions.map((question) => (
              <CreateJobInput
                key={question.id}
                id={question.id}
                label={question.question}
                fullSize={true}
                type='textarea'
                defaultValue={customAnswers?.[question?.id]}
                required={ownApply || Boolean(question.is_required)}
                onChange={(val) =>
                  setCustomAnswers((prev) => ({
                    ...prev,
                    [question.id]: val,
                  }))
                }
              />
            ))
          : null}
      </div>
    </form>
  )
}

export default ApplyForm
